import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'pilates-reformer-pronto-scadenza-offerta';
const DURATA_MS = 24 * 60 * 60 * 1000;
interface TempoRimanente {
  ore: number;
  minuti: number;
  secondi: number;
}
export function AnnouncementBar() {
  const [tempo, setTempo] = useState<TempoRimanente>({
    ore: 24,
    minuti: 0,
    secondi: 0
  });
  useEffect(() => {
    const salvata = Number(window.localStorage.getItem(STORAGE_KEY));
    let scadenza = Number.isFinite(salvata) && salvata > Date.now() ? salvata : Date.now() + DURATA_MS;
    window.localStorage.setItem(STORAGE_KEY, String(scadenza));
    const aggiorna = () => {
      const adesso = Date.now();
      if (scadenza <= adesso) {
        scadenza = adesso + DURATA_MS;
        window.localStorage.setItem(STORAGE_KEY, String(scadenza));
      }
      const secondiTotali = Math.max(0, Math.ceil((scadenza - adesso) / 1000));
      setTempo({
        ore: Math.floor(secondiTotali / 3600),
        minuti: Math.floor(secondiTotali % 3600 / 60),
        secondi: secondiTotali % 60
      });
    };
    aggiorna();
    const intervallo = window.setInterval(aggiorna, 1000);
    return () => window.clearInterval(intervallo);
  }, []);
  return <aside className="flex h-10 w-full items-center justify-center gap-2 bg-petrol px-4 text-center sm:gap-3" data-id="element-20" data-mp="3sfzz64m5vobw">
      <p className="font-note text-[10px] font-semibold leading-tight tracking-[0.08em] text-white sm:text-[11px]" data-id="element-21" data-mp="18drm0wbn1pr">
        <span className="hidden sm:inline" data-id="element-22" data-mp="p02o7tg6ecci">OFFERTA DI LANCIO A TEMPO LIMITATO · </span>L&apos;OFFERTA TERMINA TRA:
      </p>
      <div className="flex items-center gap-1 tabular-nums" aria-label={`Mancano ${tempo.ore} ore, ${tempo.minuti} minuti e ${tempo.secondi} secondi`} data-id="element-23" data-mp="tx1eg0wpxz5f">
        <Unita valore={tempo.ore} etichetta="ORE" data-id="element-24" data-mp="k6qawfgy5rz2" />
        <Separatore data-id="element-25" data-mp="17xm1585r8f47" />
        <Unita valore={tempo.minuti} etichetta="MIN" data-id="element-26" data-mp="17xc8fctbrtut" />
        <Separatore data-id="element-27" data-mp="17vj0lu6z73l8" />
        <Unita valore={tempo.secondi} etichetta="SEC" data-id="element-28" data-mp="1coc7anm08lzy" />
      </div>
    </aside>;
}
function Unita({
  valore,
  etichetta
}: {
  valore: number;
  etichetta: string;
}) {
  return <span className="whitespace-nowrap font-heading text-xs font-semibold text-white" data-id="element-29" data-mp="1mi87wi7gyl26">
      {String(valore).padStart(2, '0')}
      <span className="ml-0.5 font-note text-[8px] font-semibold tracking-[0.08em] text-sage" data-id="element-30" data-mp="1clv6sz9lh4xe">{etichetta}</span>
    </span>;
}
function Separatore() {
  return <span className="font-heading text-xs font-semibold text-white/40" data-id="element-31" data-mp="18k9xfnw9r8ry">:</span>;
}